import { render, staticRenderFns } from "./GalleryIndexItem.vue?vue&type=template&id=5c504228&"
import script from "./GalleryIndexItem.vue?vue&type=script&lang=js&"
export * from "./GalleryIndexItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports